import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { searchProducts } from "../../../Redux/Search_apis/slice";
import {
  SearchProduct,
  SearchQueryDto,
} from "../../../Redux/Search_apis/types";
import NavbarTwo from "../../globalcomponents/navbar/NavbarTwo";
import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import CategoriListFilter from "../productlisting/categorie/CategoriListFilter";
import { useAppSelector } from "../../../Redux/hooks";
import {
  fetchBrandMappings,
  fetchChildCategories,
  fetchParentCategories,
  fetchSubCategories,
} from "../../../Redux/filters/slice";
import {
  fetchProductById,
  fetchProducts,
  fetchPublicProducts,
} from "../../../Redux/ecommersProduct/slice";
import { useCart } from "../../../context/CartContext";
import {
  AddToCartRequest,
  CartType,
  ProductType,
} from "../../../Redux/custmoer_cart_service/types";
import { Product } from "../../../Redux/ecommersProduct/types";
import SponsoredProductCard from "../../globalcomponents/product/SponsoredProductCard";

const ProductList = () => {
  const [searchParams] = useSearchParams();
  const [superCategory, setSuperCategory] = useState(
    searchParams.get("superCategory") || "",
  );
  const { addItemToCart, loading: cartLoading, error: cartError } = useCart();

  const { parentCategories, subCategories, childCategories, brandMappings } =
    useAppSelector((state: RootState) => state.filters);

  const query = searchParams.get("q") || "";
  const dispatch = useDispatch<AppDispatch>();

  const { data, loading, error } = useAppSelector(
    (state: RootState) => state.search.searchResults,
  );

  useEffect(() => {
    if (data && data?.items.length > 0 && !superCategory) {
      setSuperCategory(data?.items[0].categoryHierarchy?.superCategory);
    }
  }, [data, superCategory]);

  useEffect(() => {
    if (query) {
      dispatch(searchProducts({ q: query, page: 1, limit: 100 }));
    }
    dispatch(fetchPublicProducts({ search: query || undefined, page: 1, limit: 1 }));
  }, [query, dispatch]);

  const sponsoredSlots = useAppSelector(
    (state: RootState) => state.eCommerceProducts.sponsoredSlots,
  );

  const [filters, setFilters] = useState({
    parentCategory: searchParams.get("parentCategory") || "",
    subCategory: searchParams.get("subCategory") || "",
    childCategory: searchParams.get("childCategory") || "",
    brandId: searchParams.get("brandId") || "",
    minPrice: searchParams.get("minPrice")
      ? Number(searchParams.get("minPrice"))
      : undefined,
    maxPrice: searchParams.get("maxPrice")
      ? Number(searchParams.get("maxPrice"))
      : undefined,
    page: Number(searchParams.get("page")) || 1,
    limit: 20,
  });

  useEffect(() => {
    if (superCategory) {
      dispatch(fetchParentCategories({ superCategory , showOnFilters:true , showOnWebsite:true }));
      dispatch(fetchBrandMappings({ superCategory, page: 1, limit: 20 }));
    }
  }, [superCategory, dispatch]);

  useEffect(() => {
    if (filters.parentCategory) {
      dispatch(fetchSubCategories({ parentCategory: filters.parentCategory , showOnFilters:true , showOnWebsite:true }));
    }
  }, [filters.parentCategory, dispatch]);

  useEffect(() => {
    if (filters.subCategory) {
      dispatch(fetchChildCategories({ subCategory: filters.subCategory , showOnFilters:true , showOnWebsite:true }));
    }
  }, [filters.subCategory, dispatch]);
  const { currentProduct } = useAppSelector(
    (state: RootState) => state.eCommerceProducts,
  );

  const fetchproduct = async (id: string) => {
    dispatch(fetchProductById(id));
    if (currentProduct) {
      handleAddToCart(currentProduct);
    }
  };
  const handleAddToCart = async (currentProduct: Product) => {
    const currentVariation = currentProduct.variations?.[0];
    const addToCartData: AddToCartRequest = {
      productId: currentProduct._id,
      productName: currentProduct.name,
      productImage: currentProduct.mainImage,
      productType: ProductType.PHYSICAL,
      variantId: currentVariation?.ssin,
      variantName: currentVariation?.sku,
      quantity: 1,
      unitPrice: currentVariation?.pricing?.finalPrice || 0,
      sellerId: currentProduct.creatorId,
      sellerName: currentProduct.vendors?.marketedBy || "",
      isMLMProduct: false,
      isAdminProduct: currentProduct.createdBy === "ADMIN" ? true : false,
    };

    try {
      const resultAction = await addItemToCart(addToCartData, CartType.ECOMMERCE);

      // Guests get a sign-in toast + redirect from CartContext instead
      if (!resultAction) return;

      const addToCart_fulfilled = (action: any) => action.type.endsWith("/fulfilled");

      if (addToCart_fulfilled(resultAction)) {
        // Automatically open the side cart
        const offcanvasElement = document.getElementById("offcanvasMiniCart");
        if (offcanvasElement) {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && (window as any).bootstrap.Offcanvas) {
            const bsOffcanvas = new (window as any).bootstrap.Offcanvas(
              offcanvasElement,
            );
            bsOffcanvas.show();
          }
        }
      } else {
        alert(cartError || "Failed to add item to cart");
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };
  const searchproducts = () => {
    const searchQuery: SearchQueryDto = {
      q: query,
      page: filters.page,
      limit: filters.limit,
      filters: {
        category:
          filters.childCategory ||
          filters.subCategory ||
          filters.parentCategory ||
          superCategory
            ? {
                ids: [
                  filters.childCategory ||
                    filters.subCategory ||
                    filters.parentCategory ||
                    superCategory,
                ].filter(
                  (id): id is string => typeof id === "string" && id.length > 0,
                ),
              }
            : undefined,
        brand: filters.brandId ? [String(filters.brandId)] : [],
        price:
          filters.minPrice !== undefined || filters.maxPrice !== undefined
            ? {
                min: filters.minPrice,
                max: filters.maxPrice,
              }
            : undefined,
      },
    };

    dispatch(searchProducts(searchQuery));
  };

  const handleFilterChange = (newFilters: Partial<typeof filters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters, page: 1 }));
    searchproducts();
  };

  const handlePageChange = (newPage: number) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
    searchproducts();
  };

  const renderProductCard = (product: SearchProduct) => {
    const pricing = product.variations?.[0]?.pricing;
    const finalPrice = pricing?.finalPrice || 0;
    const unitPrice = pricing?.unitPrice || 0;
    const discount = unitPrice > finalPrice ? Math.round(((unitPrice - finalPrice) / unitPrice) * 100) : 0;

    return (
      <>
        <div className="col-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card h-100 px-0 px-md-2 border-radius-lg shadow-none mb-3">
            <a href={`/DetailPage/${product.id}`}>
              <div className="card-header p-0 position-relative border-radius-lg z-index-2 bg-gray">
                <div className="d-block blur-shadow-image">
                  <img
                    src={product.mainImage}
                    alt="img-blur-shadow"
                    className="img-fluid p-2 p-md-3 w-100"
                    loading="lazy"
                    style={{ objectFit: "contain", height: "200px" }}
                    onError={(e) => {
                      e.currentTarget.src = "../../assets/img/salarlogo.png";
                    }}
                  />
                </div>
              </div>
            </a>
            <div className="p-2 text-start lh-0">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <b className="fw-bold fs-6 fs-md-5  text-md-truncate  lh-1">
                    <a href={`/DetailPage/${product.id}`} className="text-dark">
                      {product.name.length > 20
                        ? product.name.slice(0, 20) + "..."
                        : product.name}
                    </a>
                  </b>
                </div>
                <div>
                  <span className="text-black text-xs">
                    <i className="bi bi-star-fill me-1 text-xxs"></i>
                    {product.reviews || "0.0"}
                  </span>
                </div>
              </div>
              <div className=" mt-1">
                <div className=" lh-1">
                  <b className="fw-normal text-xs text-md-sm">
                    {product.description.length > 80
                      ? product.description.slice(0, 80) + "..."
                      : product.description}
                  </b>
                </div>
              </div>
            </div>
            <div className=" d-flex flex-wrap justify-content-between align-items-center mb-2 px-2 gap-1">
              <div>
                <b className="font-bold fs-6 fs-md-5 text-black my-auto">
                  <sup className=" fw-normal">₹</sup>
                  {product?.variations?.[0]?.pricing?.finalPrice}{" "}
                  <sub>
                    <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                    <b className="fw-normal text-black text-xxs text-decoration-line-through">
                      {product?.variations?.[0]?.pricing?.unitPrice || 0}
                    </b>
                    <b className="fw-bold text-danger text-xs ms-1">
                      {product?.variations?.[0]?.pricing?.unitPrice &&
                      product?.variations?.[0]?.pricing?.unitPrice >
                        product?.variations?.[0]?.pricing?.finalPrice
                        ? (
                            ((product?.variations?.[0]?.pricing?.unitPrice -
                              product?.variations?.[0]?.pricing?.finalPrice) /
                              product.variations[0].pricing.unitPrice) *
                            100
                          ).toFixed(0) + "% off"
                        : ""}
                    </b>
                  </sub>
                </b>
              </div>
              <div>
                <button
                  className=" btn btn-xs btn-sm-sm btn-yellow px-2 py-1"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasMiniCart"
                  aria-controls="offcanvasMiniCart"
                  onClick={() => fetchproduct(product.id)}
                  disabled={cartLoading}
                >
                  {cartLoading ? "Adding..." : "Add "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="bg-light min-vh-100">
        <NavbarTwo />
        <CategoriesBar />

        <div className="container py-3 py-lg-4">
          {/* Mobile Filter Toggle - Visible only on mobile */}
          <div className="d-lg-none mb-3">
            <div className="bg-white p-2 border-radius-lg shadow-sm d-flex justify-content-between align-items-center">
              <button
                className="btn btn-outline-primary btn-sm mb-0 d-flex align-items-center gap-2"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileFilterOffcanvas"
              >
                <i className="bi bi-filter-left fs-5"></i>
                <span>Filters</span>
              </button>
              <div className="text-muted text-xs">{data?.total || 0} items</div>
            </div>
          </div>

          <div className="row g-3 g-lg-4">
            <div className="col-lg-3 d-none d-lg-block">
              <div
                className="bg-white p-3 border-radius-lg shadow-sm sticky-top"
                style={{ top: "100px" }}
              >
                <h5 className="fw-bold mb-3">Filters</h5>
                <CategoriListFilter
                  superCategory={superCategory}
                  parentCategories={parentCategories.data}
                  subCategories={subCategories.data}
                  childCategories={childCategories.data}
                  brandMappings={brandMappings.data}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                />
              </div>
            </div>

            {/* Product Listing */}
            <div className="col-12 col-lg-9">
              <div className="d-flex justify-content-between align-items-center mt-2 mt-md-0 mb-3">
                <h6 className="mb-0 fs-6 fs-md-5">
                  {query ? `Results for "${query}"` : "All Products"}
                  <span className="text-muted fs-6 ms-2 fw-normal d-none d-sm-inline">
                    ({data?.total || 0} items found)
                  </span>
                </h6>
              </div>

              {sponsoredSlots.length > 0 && (
                <div className="row mb-3">
                  {sponsoredSlots.map((slot) => (
                    <SponsoredProductCard key={slot.impressionId} slot={slot} />
                  ))}
                </div>
              )}

              {loading ? (
                <div className="d-flex justify-content-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <div className="alert alert-danger border-radius-lg shadow-sm">
                  {error}
                </div>
              ) : data?.items?.length === 0 ? (
                <div className="text-center py-5 bg-white border-radius-lg shadow-sm">
                  <i className="bi bi-search fs-1 text-muted mb-3 d-block"></i>
                  <h3>No products found</h3>
                  <p className="text-muted">
                    Try a different search term or filter
                  </p>
                </div>
              ) : (
                <div className="row row-cols-5 g-3">
                  {data?.items.map(renderProductCard)}
                </div>
              )}

              {/* Pagination */}
              {data && data.total > filters.limit && (
                <nav className="mt-5 d-flex justify-content-center overflow-auto">
                  <ul className="pagination pagination-primary gap-1 gap-md-2 flex-wrap justify-content-center">
                    <li
                      className={`page-item ${filters.page === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link border-radius-md border-0 bg-white shadow-sm"
                        onClick={() => handlePageChange(filters.page - 1)}
                        disabled={filters.page === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {Array.from(
                      {
                        length: Math.min(
                          5,
                          Math.ceil(data.total / filters.limit),
                        ),
                      },
                      (_, i) => {
                        const pageNum = i + 1;
                        return (
                          <li
                            key={pageNum}
                            className={`page-item ${filters.page === pageNum ? "active" : ""}`}
                          >
                            <button
                              className="page-link border-radius-md border-0 shadow-sm"
                              onClick={() => handlePageChange(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        );
                      },
                    )}
                    <li
                      className={`page-item ${filters.page >= Math.ceil(data.total / filters.limit) ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link border-radius-md border-0 bg-white shadow-sm hover-bg-primary"
                        onClick={() => handlePageChange(filters.page + 1)}
                        disabled={
                          filters.page >= Math.ceil(data.total / filters.limit)
                        }
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Filter Offcanvas */}
        <div
          className="offcanvas offcanvas-start"
          tabIndex={-1}
          id="mobileFilterOffcanvas"
          aria-labelledby="mobileFilterOffcanvasLabel"
        >
          <div className="offcanvas-header border-bottom">
            <h5
              className="offcanvas-title fw-bold"
              id="mobileFilterOffcanvasLabel"
            >
              Filters
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body p-0">
            <CategoriListFilter
              superCategory={superCategory}
              parentCategories={parentCategories.data}
              subCategories={subCategories.data}
              childCategories={childCategories.data}
              brandMappings={brandMappings.data}
              filters={filters}
              onFilterChange={handleFilterChange}
            />
          </div>
          <div className="offcanvas-footer p-3 border-top">
            <button
              className="btn btn-primary w-100 mb-0"
              data-bs-dismiss="offcanvas"
            >
              Show {data?.total || 0} Results
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;
